﻿import LookupService from '/src/common/lookups/LookupService'

export const useLookupStore = defineStore('lookup', () => {
    const lookups = ref(null);

    async function Update() {
        lookups.value = await LookupService.GetLookupGroups();
    }

    function GetDescription(group, id) {
        try {
            let lookup = lookups.value.find(l => l.Group == group);
            if (!lookup) return '';
            let val = lookup.Lookups.find(l => l.LookupId == id);
            return val.Description;
        } catch {
            return '';
        }
    }

    function GetProperty(group, id, prop) {
        try {
            let lookup = lookups.value.find(l => l.Group == group);
            if (!lookup) return '';
            let val = lookup.Lookups.find(l => l.LookupId == id);
            return val[prop];
        } catch {
            return '';
        }
    }

    function GetLookups(group) {
        let lookup = lookups.value.find(l => l.Group == group);
        if (!lookup) return [];
        return lookup.Lookups;
    }

    function GetEditors(group) {
        let lookup = lookups.value.find(l => l.Group == group);
        if (!lookup) return [];
        return lookup.Editors;
    }

    function GetLookup(name, value) {
        let lookups = GetLookups(name);
        let lookup = lookups.find(l => l.LookupId == value);
        return lookup;
    }

    return {
        lookups,
        Update,
        GetDescription,
        GetProperty,
        GetLookups,
        GetLookup,
        GetEditors
    }
}, {
    persist: {
        key: 'municrm.lookups',
        storage: window.sessionStorage,
    },
})